/**
 * WorksCarousel — Works セクションのカード（REC 01〜03）を1枚ずつ表示し、
 * 左右ボタンでループ切替する。3D の TV（画面左）と共存する 2D+3D 構成のための UI。
 *
 * 切替時に 'workSelected' イベント（{ index, videoId }）を発火する。
 * 将来、選択した作品の動画を TV オブジェクト側で流す連動に使う。
 */
export default class WorksCarousel {
    constructor() {
        this.root = document.querySelector('.works-carousel');
        if (!this.root) return;

        this.items = Array.from(this.root.querySelectorAll('.work-item'));
        this.current = Math.max(0, this.items.findIndex(item => item.classList.contains('is-active')));
        this.indicator = this.root.querySelector('.carousel-current');

        this.root.querySelector('.carousel-prev')?.addEventListener('click', () => {
            this.show(this.current - 1);
        });
        this.root.querySelector('.carousel-next')?.addEventListener('click', () => {
            this.show(this.current + 1);
        });
    }

    show(index) {
        if (!this.items.length) return;

        // ループ式（REC 03 の次は 01）
        const next = (index + this.items.length) % this.items.length;
        if (next === this.current) return;

        this.items.forEach((item, i) => {
            item.classList.toggle('is-active', i === next);
        });
        this.current = next;

        if (this.indicator) {
            this.indicator.textContent = String(next + 1).padStart(2, '0');
        }

        // 3D 層（TV など）への連動用フック
        document.dispatchEvent(new CustomEvent('workSelected', {
            detail: {
                index: next,
                videoId: this.items[next].dataset.videoId ?? null
            }
        }));
    }

}
